"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useRequireAuth = require("./useRequireAuth");
Object.keys(_useRequireAuth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useRequireAuth[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useRequireAuth[key];
    }
  });
});